/** Label countdown QR handover — `M:SS` atau teks kedaluwarsa. */
export function qrCountdownLabel(
  expiresAt: string | undefined,
  nowMs: number,
  expiredLabel: string,
  remainingLabel: (min: number, sec: string) => string,
): string {
  if (!expiresAt) return expiredLabel
  const ms = new Date(expiresAt).getTime() - nowMs
  if (ms <= 0) return expiredLabel
  const min = Math.floor(ms / 60000)
  const sec = String(Math.floor((ms % 60000) / 1000)).padStart(2, '0')
  return remainingLabel(min, sec)
}
